module.exports = __webpack_public_path__ + "static/img/listHQ.ad4478e.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/listHQ.png
// module id = 9fdW
// module chunks = 6